import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {CalendarModale} from './CalendarModale';
import {useCallback} from 'react';
import {Calendar} from './Calendar/Calendar';
import {useLivraisonsPossiblesContext, useSelectedLivraison} from 'ff-common';
import {useAfficherCadencier} from '@/hooks/livraison/use-afficher-cadencier';
import {useAfficherPanier} from '@/hooks/livraison/use-afficher-panier';
import {Box} from '@chakra-ui/react';
import {useHalStates} from '@synako/haligator';
import {useLivraisons} from '@/haligator-factory';

export const ChangerDateModale = NiceModal.create(
  ({derniereAction}: {derniereAction?: string}) => {
    const modal = useModal();
    const afficherPanier = useAfficherPanier();
    const afficherCadencier = useAfficherCadencier();

    const {
      livraisonSelectionnee: livraisonDepuisContexte,
      setLivraisonSelectionnee: setLivraisonDansContexte,
    } = useLivraisonsPossiblesContext();

    const {selectedLivraison, onDateSelect, onCancel} = useSelectedLivraison(
      livraisonDepuisContexte,
      () => {
        /* no-op */
      }, // Explicit no-op function with comment
      modal,
    );

    const onValidate = useCallback(async () => {
      const newEffectiveTemp = selectedLivraison.data.temperature_effective;

      if (!newEffectiveTemp) {
        return;
      }

      setLivraisonDansContexte(selectedLivraison);

      if (derniereAction === 'valide') {
        afficherCadencier(selectedLivraison.data.tolede.date_de_livraison);
      } else {
        if (location.pathname.includes('panier')) {
          afficherPanier(selectedLivraison.data.tolede.date_de_livraison);
        }
      }
      modal.remove();
    }, [
      modal,
      selectedLivraison,
      setLivraisonDansContexte,
      afficherCadencier,
      afficherPanier,
      derniereAction,
    ]);

    const livraisonsPossibles = useHalStates(
      useLivraisons().followAll('items'),
    );
    if (!livraisonsPossibles.states || livraisonsPossibles.error) {
      return;
    }

    return (
      <CalendarModale
        modal={modal}
        messageKey={'default'}
        onCancel={onCancel}
        size_desktop={'xl'}
      >
        <Box
          w='100%'
          borderRadius='8px'
          border='1px solid'
          borderColor='gray.light'
        >
          <Calendar
            onCancel={onCancel}
            onDateSelect={onDateSelect}
            onValidate={onValidate}
            selectedLivraison={selectedLivraison}
          />
        </Box>
      </CalendarModale>
    );
  },
);
